import Image from 'next/image';

function Reviews({
    nameOfPerson,
    titleOfPerson,
    personLogo,
    companyLogo,
    quote,
    priority = false
}) {
    return (
        <div className="mb-[30px] min-w-[295px] rounded-[9px] bg-white py-[22px] shadow-md">
            <div className="mx-auto max-w-[253px]">
                {!companyLogo && (
                    <div className="mb-[16px] flex h-[43px] w-[67px] items-center justify-center rounded-[5px] bg-indigo-200">
                        <div className="text-[7px] font-bold text-blue-600">
                            {nameOfPerson || 'Anonymous'}
                        </div>
                    </div>
                )}
                {companyLogo && (
                    <div className="relative h-[125px] w-full">
                        <Image
                            src={companyLogo}
                            fill
                            sizes="253px"
                            quality={50}
                            className="object-contain"
                            alt={`Company ${nameOfPerson}`}
                            priority={priority}
                        />
                    </div>
                )}

                <hr className="my-[16px] h-[2px] bg-indigo-100" />

                <div className="text-lg pb-[25px] font-[400] leading-[28px] text-blue-600">
                    {quote || 'No quote'}
                </div>

                <div className="flex">
                    <div className="mr-[18px]">
                        {!personLogo && (
                            <div className="flex size-[61px] items-center justify-center rounded-[100px] bg-indigo-200 text-[7px] font-bold text-blue-600">
                                {nameOfPerson || 'Camera shy'}
                            </div>
                        )}
                        {personLogo && (
                            <Image
                                quality={75}
                                src={personLogo}
                                alt={nameOfPerson}
                                width={61}
                                height={61}
                            />
                        )}
                    </div>

                    <div className="flex flex-col items-start justify-center border-l border-indigo-100 pl-[18px]">
                        <div className="text-[10px] font-bold text-fuschia-700">
                            {nameOfPerson || 'Anonymous customer'}
                        </div>
                        <div className="text-[10px] font-normal text-blue-600">
                            {titleOfPerson || 'No title provided'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Reviews;
